import React, { useCallback, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { userJoin } from './auth/ducks/auth';
import FieldError from '../common/FieldError';
import { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from "react-toastify";
import { scrollToElement } from 'lib/userFunctions';

const initialState = {
    type: 'student',
    userid: '',
    password: '',
    password_confirm: '',
    name: '',
    privacyY: '',
    school_grade: 6,
    school_class: 1,
    student_num: 1
};

function joinReducer(state, action) {
    return { ...state, [action.type]: action.value };
}

const UserJoin = () => {
    const { school } = useParams();
    const [state, setState] = useReducer(joinReducer, initialState);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    console.log(state);


    const handleInput = useCallback((event) => {
        const target = event.target
        let value = target.value;

        if (target.name === 'userid') {
            const regExp = /[^0-9a-zA-Z]/g;
            value = value.toLowerCase().replace(regExp, '');
        }
        if (target.name === 'privacyY') value = (event.target.checked) ? 'Y' : '';
        setState({ type: target.name, value: value });
    }, []);

    const onSubmit = (event) => {
        if (state.privacyY !== 'Y') {
            toast.error("이용약관,개인정보처리방침에 동의합니다.");
            return false;
        }

        let tmpdata = {
            ...state,
            type: state.type,
            userid: state.userid,
            password: state.password,
            password_confirm: state.password_confirm,
            name: state.name,
            school_grade: state.school_grade,
            school_class: state.school_class,
            student_num: state.student_num,
            school_code: window.schoolCode,
        }
        setLoading(true);
        let result = dispatch(userJoin(tmpdata));
        setErrors([]);
        result.then(res => {
            alert(tmpdata.name + '님 가입을 축하합니다.');
            navigate({ pathname: `/${school}/signin`, search: '' });
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            const errorData = createFetchErrorMessage(err);
            if (errorData.errors.length > 0) {
                setErrors(errorData.errors);
                toast.error("입력 정보가 유효하지 않습니다. 확인해주세요.");
            } else {
                toast.error(errorData.message);
            }
            scrollToElement();
        });
        event.preventDefault();
    }


    return (
        <div className="subpage">
            <div id="contents" className="member join">
                <div className="section">
                    <div className="inner">
                        <h2><span>회원가입</span></h2>
                        <form onSubmit={onSubmit}>
                            <div className="join_input_area">
                                <div className="row mgT0">
                                    <h4>구분</h4>
                                    <div className="input_radio">
                                        <input type="radio" name="type" value="student" id="student" checked={state.type === 'student'} onChange={handleInput} /><label htmlFor="student">어린이</label>
                                        <input type="radio" name="type" value="teacher" id="teacher" checked={state.type === 'teacher'} onChange={handleInput} /><label htmlFor="teacher">선생님</label>
                                        <input type="radio" name="type" value="parent" id="parent" checked={state.type === 'parent'} onChange={handleInput} /><label htmlFor="parent">부모님</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <h4>아이디</h4>
                                    <FieldError name="userid" errors={errors} >
                                        <input type="text" name="userid" placeholder="아이디를 입력하세요." onChange={handleInput} value={state.userid} maxLength={10} required />
                                    </FieldError>
                                </div>

                                <div className="row">
                                    <h4>비밀번호</h4>
                                    <FieldError name="password" errors={errors} >
                                        <input type="password" name="password" placeholder="비밀번호를 입력하세요." onChange={handleInput} value={state.password} required />
                                    </FieldError>
                                </div>
                                <div className="row">
                                    <h4>비밀번호 확인</h4>
                                    <FieldError name="password_confirm" errors={errors} >
                                        <input type="password" name="password_confirm" placeholder="비밀번호를 한번 더 입력하세요." onChange={handleInput} required />
                                    </FieldError>
                                    <FieldError name="validPassword" errors={errors} ></FieldError>
                                </div>

                                <div className="row">
                                    <h4>별명 또는 이름</h4>
                                    <FieldError name="name" errors={errors} >
                                        <input type="text" name="name" placeholder="이름" onChange={handleInput} maxLength={7} required />
                                    </FieldError>
                                </div>

                                <div className="row">
                                    <div className="col4">
                                        <h4>학년</h4>
                                        <FieldError name="school_grade" errors={errors} >
                                            <input type="number" max={6} defaultValue={6} value={state.school_grade}
                                                onBlur={(e) => {
                                                    if (e.target.value < 1) e.target.value = 1;
                                                    if (e.target.value > 6) e.target.value = 6;
                                                    setState({ type: "school_grade", value: e.target.value });
                                                }}
                                                onChange={(e) => setState({ type: "school_grade", value: e.target.value })} />
                                        </FieldError>
                                    </div>
                                    <div className="col4">
                                        <h4>반</h4>
                                        <FieldError name="school_class" errors={errors} >
                                            <input type="number" max={20} defaultValue={1} value={state.school_class}
                                                onBlur={(e) => {
                                                    if (e.target.value < 1) e.target.value = 1;
                                                    if (e.target.value > 20) e.target.value = 20;
                                                    setState({ type: "school_class", value: e.target.value });
                                                }}
                                                onChange={(e) => setState({ type: "school_class", value: e.target.value })} />
                                        </FieldError>
                                    </div>
                                    <div className="col4">
                                        <h4>번호</h4>
                                        <FieldError name="student_num" errors={errors} >
                                            <input type="number" max={40} defaultValue={1} value={state.student_num}
                                                onBlur={(e) => {
                                                    if (e.target.value < 1) e.target.value = 1;
                                                    if (e.target.value > 40) e.target.value = 40;
                                                    setState({ type: "student_num", value: e.target.value });
                                                }}
                                                onChange={(e) => setState({ type: "student_num", value: e.target.value })} />
                                        </FieldError>
                                    </div>
                                </div>
                                <div className="row">
                                    <h4>약관 동의</h4>
                                    <div className="input_check">
                                        <input type="checkbox" name="privacyY" id="privacyY" value="Y" onChange={handleInput} /><label htmlFor="privacyY">이용약관&middot;개인정보처리방침에 동의합니다.</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {!loading &&
                            <div className="btn_area alignC">
                                <button type="button" className="btn _turq" onClick={onSubmit}>회원가입</button>
                                <Link to={`/${window.schoolCode}/signin`} className="btn _border">취소</Link>
                            </div>
                        }
                    </div>
                </div>
            </div>

        </div>
    );
}
export default UserJoin;